const { useLayoutEffect } = require("react");

(function ($) {
    // Load here
    menuToggle();
    let header = $('#site-header');
    let heightHeader = header.height();
    let widthInner = window.innerWidth;
    let viewportTop;
    let isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        $(window).scrollTop() == 0 ? viewportTop = $(window).scrollTop()+heightHeader : viewportTop=$(window).scrollTop();
        // window.onresize = () =>{
        //     let widthOutter = window.innerWidth;
        //     if(widthOutter >990){
        //         windowScroll(header,heightHeader,viewportTop,scroll,2);
        //     }
        // }
        if(widthInner >990){
            windowScroll(header,heightHeader,viewportTop,scroll);
        }

    function menuToggle() {
        $('.nav-toggle, .nav-close').on('click', function(e) {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
            //if (isIOS) {
            let positionCurrent = window.scrollY
                window.scrollTo(0, positionCurrent + 1);
            //}
            let navMb = $('.nav-main');
            navMb.toggleClass('show');
            $('html').toggleClass('overflow-hidden');
        });
        $('.nav-main li').each(function(i, li) {
            let hasChild = $(li).find('ul');

            if(hasChild.length) {
                let menuItem = $(li).children('a');
                menuItem.addClass('nav-header');

                hasChild.find('li').each(function(i,e) {
                    let menuItem = $(e).find('a');
                    menuItem.addClass('nav-end');
                });
            }
            else {
                let menuItem = $(li).children('a');
                menuItem.addClass('nav-end');
            }
        })
    }
    function windowScroll(header,heightHeader,viewportTop,scroll){
        $(window).on('scroll', function() {
            let scroll = $(window).scrollTop();
             behaviorScrolling(header,heightHeader,viewportTop,scroll);
            viewportTop = scroll;
        });
    }
    function behaviorScrolling(header,heightHeader,viewportTop,scroll) {
        if(header){
            if(scroll > viewportTop) {
                header.hasClass('with-bg') ? header.removeClass('with-bg') : '';
                header.hasClass('hidden-header') ? '' : header.addClass('hidden-header');
            } else{
                header.hasClass('with-bg') ? '' : header.addClass('with-bg');
                header.hasClass('hidden-header') ? header.removeClass('hidden-header') : '';
            } 
            if(scroll <= heightHeader){
                header.hasClass('with-bg') ? header.removeClass('with-bg') : '';
                header.hasClass('hidden-header') ? header.removeClass('hidden-header') : '';
            }
        }
    }

})(jQuery);